
import Vue from 'vue'
import Component from 'vue-class-component'
import Error from "@/components/Error.vue"

@Component({
  components: {
    Error
  }
})
export default class Register extends Vue {
  private loading = false;
  public passwordShow = false
  public confirmPasswordShow = false
  public valid = false
  private firstname = ''
  private lastname = ''
  private termsAndConditions = false
  private termsAndConditionRules = [
    (v: any) => !!v || this.$t('account.acceptTermsAndConditionsRule')
  ]

  private nameRules = [
    (v: any) => !!v || this.$t('global.required')
  ]

  public email = ''
  public emailRules = [
    (v: any) => !!v || this.$t('global.required'),
    (v: any) => /.+@.+/.test(v) || this.$t('account.mailNotValid')
  ]

  public password = ''
  public confirmPassword = ''
  public passwordRules = [
    (v: any) => !!v || this.$t('global.required'),
    (v: any) => /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/.test(v) || this.$t('account.passwordValidationRule')
  ]

  passwordConfirmationRule () {
    return this.password === this.confirmPassword || this.$t('account.passwordConfirmation')
  }

  get error () {
    const authenticationError = this.$store.getters["account/authenticationError"]
    const globalError = this.$store.getters["error/error"]
    if (authenticationError || globalError) {
      this.loading = false
    }
    return authenticationError
  }

  created () {
    if (this.$route.params) {
      if (this.$route.params.email) {
        this.email = this.$route.params.email
      }
      if (this.$route.params.password) {
        this.password = this.$route.params.password
        this.confirmPassword = this.$route.params.password
      }
    }
  }

  public goToLogin () {
    this.$store.commit('account/setAuthenticationError', null)
    this.$router.push({ name: 'login' })
  }

  public register () {
    if (
      (this.$refs.form as Vue & { validate: () => boolean }).validate()
    ) {
      this.createUser()
    }
  }

  async createUser () {
    this.loading = true
    const user = {
      firstName: this.firstname,
      lastName: this.lastname,
      email: this.email,
      password: this.password
    }
    this.$store.dispatch("account/register", user)
    this.loading = false
  }
}
